import { useEffect } from "react";

import { useActiveAppTheme } from "~/contexts/AppTheme/useAppThemeStore.ts";

/**
 * Writes the active theme to `data-theme` on the html element. The attribute sits on the html element, not on a
 * wrapper, so the portals of the dialogs and popovers get the theme as well.
 */
export const AppThemeAttribute = () => {
    const theme = useActiveAppTheme();

    useEffect(() => {
        document.documentElement.dataset.theme = theme;
    }, [theme]);

    return null;
};
